import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that scrolls to top whenever the route changes
 */
const ScrollToTopOnNavigation = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTopOnNavigation;
